module.exports = __webpack_public_path__ + "img/About-us_custon-interior.87b2eead.jpg";